import api from '@/helpers/api';

export default {
  // ===========================
  // ORGANISATION TAGS
  // ===========================

  fetchOrganisationContactTags({ commit }, payload) {
    // @todo: only load if not already loaded
    if (!payload.silent) {
      commit('START_LOADING_ORGANISATION_CONTACT_TAGS', true);
    }
    const request = api('GET', `organisation/${payload.organisationId}/contact-tags`, payload.data, null, 'w');
    request
      .then((response) => {
        if (response.status === 200) {
          commit('SET_ORGANISATION_CONTACT_TAGS', response.data);
        }
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      });
    return request;
  },
  createContactTag({ commit }, payload) {
    // promise-based approach - return promise from api
    // note: could use async/await here
    return new Promise((resolve, reject) => {
      api('POST', `organisation/${payload.organisationId}/contact-tags`, payload.data, null, 'w')
        .then((response) => {
          if (response.status === 200) {
            // for some reason, backend IS returning a list of tags so first of all we need to find the one we just created
            const tagData = response.data.tag;
            // commit('APPEND_ORGANISATION_CONTACT_TAGS', tagData);
            resolve({
              id: tagData.id,
              name: tagData.name,
              business: tagData.business,
            });
          }
        })
        .catch((error) => {
          commit('API_ERROR', error.response);
          reject(error);
        });
    });
  },
  updateContactTag({ commit }, payload) {
    return api('PUT', `organisation/${payload.organisationId}/contact-tags/${payload.tagId}`, payload.data, null, 'w')
      .then((response) => {
        if (response.status === 200) {
          // commit('UPDATE_TAG', {
          //   tagId: payload.tagId,
          //   data: payload.data,
          // });
        }
        return response;
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      });
  },
  deleteTag({ commit }, payload) {
    return api('DELETE', `organisation/${payload.organisationId}/contact-tags/${payload.tagId}`, null, null, 'w')
      .then((response) => {
        if (response.status === 200) {
          // commit('DELETE_TAG', payload.tagId);
        }
        return response;
      });
  },

  // ===========================
  // CONTACT TAGS
  // ===========================

  /**
   * Retrieves tags set on a contact.
   *
   * @param {*} _ Unused destructor position.
   * @param {*} payload Should contain contactId and organisationId and data parameter with tag ids and optional paging values.
   * @returns Axios request promise.
   */
  fetchUserTags(_, payload) {
    return api('GET', `organisation/${payload.organisationId}/contacts/${payload.contactId}/contact-tags`, payload.data, null, 'w');
  },
  /**
   * Adds a new tag(s) to a contact.
   *
   * @param {*} destructedObject VUEX action destructor param.
   * @param {*} payload Should contain contactId and organisationId and data parameter with tag(s) as CSV to set to contact.
   * @returns Axios request promise.
   */
  addUserTag(_, payload) {
    const request = api('POST', `organisation/${payload.organisationId}/contacts/${payload.contactId}/contact-tags`, payload.data, null, 'w');
    request.then(() => {
      // if (response.status === 200) {
      //   commit('ADD_TAG_TO_USER', payload.data.tags);
      // }
    });
    return request;
  },
  /**
   * Deletes a tag(s) on a contact.
   *
   * @param {*} _ Unused destructor position.
   * @param {*} payload Should contain contactId and organisationId and data parameter with tag id(s) in CSV.
   * @returns Axios request promise.
   */
  deleteUserTag(_, payload) {
    const request = api('DELETE', `organisation/${payload.organisationId}/contacts/${payload.contactId}/contact-tags`, payload.data, null, 'w');
    request.then((response) => {
      if (response.status === 200) {
        // commit('REMOVE_TAG_TO_USER', payload.data.tags);
      }
    });
    return request;
  },
};
